import React from 'react'
import style from './articles.style'

const KastomnyCrm = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>Подключение кастомных CRM</h2>
      <p>Со стороны CRM должен быть реализован механизм веб-хуков.</p>
      <p>При смене статуса сделки CRM должна отправить на адрес</p>
      <p>
        <strong>https://romi.center/api/crm/event/</strong> POST запрос со
        следующими параметрами:
      </p>

      <ul className={classes.articleList}>
        <li>token (авторизационный токен)</li>
        <li>id (id сделки)</li>
        <li>name (наименование сделки)</li>
        <li>sum (сумма сделки)</li>
        <li>status (id статуса сделки)</li>
        <li>cid (google client id)</li>
      </ul>
      <p>
        Параметр token генерируется автоматически в личном кабинете в разделе
        подключения кастомных CRM. Полученное в ЛК значение нужно постоянно
        передавать в POST запросах со стороны CRM.
      </p>

      <h3>Пример POST запроса</h3>
      <p>
        <strong>{`curl 'https://app.romi.center/api/crm/event' -H 'content-type: application/json' --data-binary '{ "token": "662a8397f328f7f9664a9ee64577df9d8eb11d3d87218cc65b1b8283b4049d66", "id": "2080", "name": "Тестовая сделка", "status": "1020", "sum": "1000", "cid": "1587458906.1563801830", }' --compressed`}</strong>
      </p>
    </article>
  )
}

export default style(KastomnyCrm)
